module.exports = __webpack_public_path__ + "img/sign-70.7f61a7a5.jpg";